import { render, staticRenderFns } from "./folderSvg.vue?vue&type=template&id=f1bd19f2&"
import script from "./folderSvg.vue?vue&type=script&lang=js&"
export * from "./folderSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports